// Auth utility functions for user management
// Note: Token is now stored in HTTP-only cookie by backend, so we only manage user info in localStorage

const USER_KEY = "upu_user";

// Save user info to localStorage
export const setUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

// Get user info from localStorage
export const getUser = () => {
  const userStr = localStorage.getItem(USER_KEY);
  return userStr ? JSON.parse(userStr) : null;
};

// Remove user info from localStorage
export const removeUser = () => {
  localStorage.removeItem(USER_KEY);
};

// Check if user is authenticated
// Since token is in HTTP-only cookie (not accessible via JavaScript),
// we check if user info exists in localStorage
// For more reliable check, we can use /me endpoint (see isAuthenticatedAsync)
export const isAuthenticated = () => {
  return !!getUser();
};

// Async function to check authentication by calling /me endpoint
// This is more reliable than checking localStorage
export const isAuthenticatedAsync = async () => {
  try {
    const { API_BASE_URL, API_ENDPOINTS } = await import("../config/api");
    const axiosInstance = (await import("./axios")).default;
    const response = await axiosInstance.get(API_ENDPOINTS.ME);
    if (response.data) {
      setUser(response.data); // Update user info if needed
      return true;
    }
    return false;
  } catch (error) {
    removeUser();
    return false;
  }
};
